import { HeaderContext } from '@tanstack/react-table';
import { lucideIcons, tableHelpers, Tooltip } from '@round/creatorbase-ui';
import { getMeta, OutreachResultRow } from '../../../../helpers';
import styles from './TagsHeader.module.css';

const { Pencil } = lucideIcons;

const HEADER = 'Tags';
export const EDITABLE_HINT = 'Editable until the creator is added';

type Props = HeaderContext<tableHelpers.WithLoadingRow<OutreachResultRow>, unknown>;

/** Names the column, and on the To Review tab says its cells can be edited — the one tab where every row can be. */
export const TagsHeader = ({ table }: Props) => {
    const { tab } = getMeta(table);

    if (tab !== 'TO_REVIEW') {
        return HEADER;
    }

    return (
        <span className={styles.header}>
            {HEADER}
            <Tooltip>
                <Tooltip.Trigger asChild>
                    <span className={styles.hint}>
                        <Pencil aria-hidden="true" />
                        <span className="sr-only">{EDITABLE_HINT}</span>
                    </span>
                </Tooltip.Trigger>
                <Tooltip.Content>{EDITABLE_HINT}</Tooltip.Content>
            </Tooltip>
        </span>
    );
};
